import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import 'react-table/react-table.css';
import {debounce} from 'throttle-debounce';
import {Link} from 'react-router-dom';
import moment from 'moment/min/moment-with-locales';
import Table from '../../common/table/TicketTable';
import {IconEdit, PrimaryIcon} from '../../common/Button';
import listMessages from '../../../intl/technicalDocumentations/listMessages';
import {editTechDocInternalTicketListButtonVisibility} from '../../../constants/techDocInternalTicketRights';
import {fetchTechDocInternalTicketListPageData} from '../../../actions/techDoc/actionTechDocInternalTicketListPage';
import {formatInternalTicketNumber} from '../../../utils/utils';
import get from 'get-value';
import {domains} from '../../../constants/Utils';

class ListTechDocInternalTicketTable extends React.Component {
    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(props.location.search);
        const loadedState = this.loadStateFromSessionStorage({
            listInternalTDDefaultPageSize: 10,
            listInternalTDDefaultSort: [{id: 'TICKET_NUMBER', desc: true}],
            listInternalTDDefaultFilters: [],
        });

        if (urlParams.has('status')) {
            this.state = {
                ...loadedState,
                listInternalTDDefaultFilters: [
                    {
                        id: 'STATUS',
                        value: urlParams.get('status') ? urlParams.get('status') : '',
                    }
                ]
            }
        } else {
            this.state = {
                ...loadedState,
                listInternalTDDefaultFilters: loadedState.listInternalTDDefaultFilters.filter(item => item.id !== 'GROUP')
            }
        }

        this.filtering = false;
        this.handleFetchDataDebounced = debounce(1000, this.handleFetchData);
    }

    componentDidMount() {
        window.addEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
    }

    componentWillUnmount() {
        window.removeEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
        this.saveStateToSessionStorage();
    }

    loadStateFromSessionStorage(defaults) {
        return Object.keys(defaults)
            .reduce((acc, key) => {
                if (sessionStorage.hasOwnProperty(key) && key.match(/^listInternalTD*/)) {
                    let value = sessionStorage.getItem(key);
                    value = JSON.parse(value);
                    return {
                        ...acc,
                        [key]: value,
                    };
                }
                return acc;
            }, defaults);
    }

    saveStateToSessionStorage = () => {
        for (let key in this.state) {
            if (this.state.hasOwnProperty(key) && key.match(/^listInternalTD*/)) {
                sessionStorage.setItem(key, JSON.stringify(this.state[key]));
            }
        }
    }

    handleFetchData = state => {
        this.props.fetchTechDocInternalTicketListPageData(state.pageSize, state.sorted, state.cursor, state.isNextFromPivot, this.normalizeFiltered(state));
        this.filtering = false;
        this.setState({
            listInternalTDDefaultPageSize: state.pageSize,
            listInternalTDDefaultSort: state.sorted,
            listInternalTDDefaultFilters: state.filtered
        });
    };

    fetchStrategy = state => {
        this.filtering ? this.handleFetchDataDebounced(state) : this.handleFetchData(state);
    };

    normalizeFiltered = state => {
        return state.filtered
            .filter(filterItem => filterItem.value)
            .map(filterItem => {
                if (filterItem.value instanceof Date || filterItem.id === 'IT_CREATION_TIME' || filterItem.id === 'LAST_UPDATE') {
                    return {
                        id: filterItem.id,
                        value: moment(filterItem.value).add(12, 'hours').toISOString().substr(0, 10)
                    };
                } else {
                    return filterItem;
                }
            });
    };

    render() {
        const {columns, data, pages, isLoading, handleEditClick, isNextPage, isNextFromPivot, userRoles} = this.props;

        return (
            <div className="container-fluid text-center">
                <div className="row">
                    <div className="col">
                        <Table
                            columns={[
                                {
                                    id: 'TICKET_NUMBER',
                                    accessor: 'ticketNumber',
                                    message: listMessages.TABLE_INTERNAL_TICKET_NUMBER,
                                    Cell: row => <Link
                                        to={`view/${row.original.id}`}>{get(row, 'original.pfxNumber') ? formatInternalTicketNumber(get(row, 'original.pfxNumber'), get(row, 'original.sfxNumber')) : ''}</Link>
                                },
                                ...columns]}
                            toolButtons={[
                                {
                                    handleClick: handleEditClick,
                                    component: <PrimaryIcon className="btn btn-sm"
                                                            title="Edit"
                                                            type="button"
                                                            key="editButton">
                                        <IconEdit/>
                                    </PrimaryIcon>
                                }
                            ]}
                            isLoading={isLoading}
                            data={data}
                            pages={pages}
                            handleFetchData={this.fetchStrategy}
                            handleOnFilteredChange={() => {
                                this.filtering = true;
                            }}
                            isNextPage={isNextPage}
                            isNextFromPivot={isNextFromPivot}
                            defaultFiltered={this.state.listInternalTDDefaultFilters}
                            defaultSorting={this.state.listInternalTDDefaultSort}
                            defaultPageSize={this.state.listInternalTDDefaultPageSize}
                            buttonVisibility={editTechDocInternalTicketListButtonVisibility['TD_SG_EDITOR']}
                            sgPermissions={get(userRoles, `${domains.TECHNICAL_DOCUMENTATION}.sgEditor.sgPermission`)}
                            toolSortable={true}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

ListTechDocInternalTicketTable.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    isNextPage: PropTypes.bool.isRequired,
    isNextFromPivot: PropTypes.bool.isRequired,
    pages: PropTypes.number.isRequired,
    handleEditClick: PropTypes.func.isRequired,
    fetchTechDocInternalTicketListPageData: PropTypes.func.isRequired,
    columns: PropTypes.array,
    userRoles: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    isLoading: state.techDocInternalTicketListPage.isTableLoading,
    data: state.techDocInternalTicketListPage.listData,
    isNextPage: state.techDocInternalTicketListPage.isNextPage,
    isNextFromPivot: state.techDocInternalTicketListPage.isNextFromPivot,
    pages: state.techDocInternalTicketListPage.pages,
    userRoles: state.profile.userDetail.roles,
});

export default connect(mapStateToProps, {
    fetchTechDocInternalTicketListPageData
})(ListTechDocInternalTicketTable);
